document.addEventListener("DOMContentLoaded", function () {
  let checkbox = document.querySelector("input[name=select_all][type=checkbox]");
  if (checkbox) {
    let checkableContainerClass = checkbox.getAttribute("data-checkable-container");
    checkbox.addEventListener("change", toggleAllCheckbox(checkableContainerClass));
  }
});

const toggleAllCheckbox = (checkableContainerClass) => {
  const container = document.querySelector("." + checkableContainerClass);
  return (e) => {
    const checkableThings = container.querySelectorAll("*[data-selectable]");
    for (let checkabkeThing of checkableThings) {
      checkabkeThing.checked = e.target.checked;
    }
  };
};
